import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientProvider } from '../providers/client.provider';
import { FullClientInterface, ValidationClient } from '../data';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface ValidateClientDataUseCaseParams {
    client: FullClientInterface;
    validations: ValidationClient[];
}

@Injectable()
export class ValidateClientDataUseCase implements UseCaseWithParam<ValidateClientDataUseCaseParams, Observable<Transaction<void>>> {
    constructor(private clientProvider: ClientProvider) {}

    bind(params: ValidateClientDataUseCaseParams): Observable<Transaction<void>> {
        return this.clientProvider.validateData(params.client, params.validations);
    }
}
